export const timeFormat = (number: string) => {
  const newNumber = number.toString().padStart(2, '0')
  return newNumber.toString().split('').map(Number)
}
